import React from 'react';
import { useTranslation } from 'react-i18next';
import p1 from '../../assets/revs/p001.svg';
import p2 from '../../assets/revs/p002.svg';
import p3 from '../../assets/revs/p003.svg';
import who from '../../assets/who.svg';
import heart from '../../assets/heart.svg';
import FlipBadge from '../../components/FlipBadge';

const About = () => {
  const { t } = useTranslation('about');
  
  return (
    <section id='about'>
      <div className='container'>
        <div className='s-48'></div>
        <h3 className='title-sub tc'>
          {t('about.header.title')}
        </h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma tc'>
          {t('about.header.subtitle')}
        </h4>
        <div className='s-48'></div>
        <div className='reviews bg-lpink'>
          <div className='row'>
            <div className='col-lg-8'>
              <div className='card-review first bg-white flex aifs p-4'>
                <img 
                  src={p1} 
                  alt={t('about.cards.ats.alt')} 
                  width={120}
                  height={120}
                  className='obfc'
                />
                <div className='px-3'>
                  <h4 className='c-dark'>{t('about.cards.ats.title')}</h4>
                  <p>
                    {t('about.cards.ats.description')}
                  </p>
                </div>
              </div>
              <div className='s-24'></div>
              <div className='card-review second bg-white flex aifs p-4'>
                <img 
                  src={p2} 
                  alt={t('about.cards.visualization.alt')} 
                  width={120}
                  height={120}
                  style={{ borderRadius: '50%', objectFit: 'cover' }}
                />
                <div className='px-3'>
                  <h4 className='c-dark'>{t('about.cards.visualization.title')}</h4>
                  <p>
                    {t('about.cards.visualization.description')}
                  </p>
                </div>
              </div>
              <div className='s-24 d-none-d-sm-block'></div>
            </div>
            <div className='col-lg-4'>
              <div className='card-review third bg-white p-4 obfc'>
                <img
                  src={p3}
                  alt={t('about.cards.interview.alt')} 
                  width={140}
                  height={140}
                />
                <div className='px-3'>
                  <h4 className='c-dark'>{t('about.cards.interview.title')}</h4>
                  <div className='s-10'></div>
                  <p>
                    {t('about.cards.interview.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='s-48'></div>
        <h3 className='title-sub tc'>{t('about.benefits.title')}</h3>
        <div className='s-32'></div>
        <div className='row'>
          <div className='col-lg-4'>
            <div className='card-review first bg-white flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>🔑</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.benefits.items.access.title')}</h4>
                <p>
                  {t('about.benefits.items.access.description')}
                </p>
              </div>
            </div>
            <div className='s-24'></div>
            <div className='card-review flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>💾</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.benefits.items.projects.title')}</h4>
                <p>
                  {t('about.benefits.items.projects.description')}
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='card-review third bg-white flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>🚀</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.benefits.items.experience.title')}</h4>
                <div className='s-10'></div>
                <p style={{ paddingRight: 18 }}>
                  {t('about.benefits.items.experience.description')}
                </p>
              </div>
            </div>
            <div className='s-24'></div>
            <div className='card-review first bg-white flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>👥</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.benefits.items.teamwork.title')}</h4>
                <p>
                  {t('about.benefits.items.teamwork.description')}
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='card-review flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>💼</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.benefits.items.commercial.title')}</h4>
                <p>
                  {t('about.benefits.items.commercial.description')}
                </p>
              </div>
            </div>
            <div className='s-24'></div>
            <div className='card-review third bg-white flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>🎯</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.benefits.items.own_project.title')}</h4>
                <div className='s-10'></div>
                <p style={{ paddingRight: 18 }}>
                  {t('about.benefits.items.own_project.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='s-48'></div>
        <div className='row align-items-center justify-content-center'>
          <div className='col-12 text-center'>
            <h3 className='title-sub tc mb-0' style={{ display: 'inline-flex', alignItems: 'center', gap: '24px', justifyContent: 'center', width: '100%' }}>
              {t('about.mission.title')}
              <img src={heart} alt="Миссия" style={{ maxWidth: '40px', verticalAlign: 'middle' }} />
            </h3>
          </div>
        </div>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma tc'>
          {t('about.mission.description')}
        </h4>
        <div className='s-24'></div>
        <p className='title-mini w-70 ma tc c-text'>
          {t('about.mission.expansion')}
        </p>
        <div className='s-48'></div>
        <div className='row'>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.school.title')} backText={t('about.courses.school.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.students.title')} backText={t('about.courses.students.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.language.title')} backText={t('about.courses.language.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.university.title')} backText={t('about.courses.university.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.education.title')} backText={t('about.courses.education.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.family.title')} backText={t('about.courses.family.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.fashion.title')} backText={t('about.courses.fashion.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.travel.title')} backText={t('about.courses.travel.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.job_search.title')} backText={t('about.courses.job_search.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.linkedin.title')} backText={t('about.courses.linkedin.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.data_analysis.title')} backText={t('about.courses.data_analysis.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.influence.title')} backText={t('about.courses.influence.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.media.title')} backText={t('about.courses.media.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.pr.title')} backText={t('about.courses.pr.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.science.title')} backText={t('about.courses.science.backText')} />
          </div>
          <div className='col-lg-3 col-md-4 col-sm-6 mb-4'>
            <FlipBadge title={t('about.courses.bloggers.title')} backText={t('about.courses.bloggers.backText')} />
          </div>
        </div>
        <div className='s-48'></div>
        <div className='row'>
          <div className='col-12 text-center'>
            <img src={who} alt={t('about.for_whom.title')} className="img-fluid" style={{ maxWidth: '500px' }} />
          </div>
        </div>
        <div className='s-48'></div>
        <h3 className='title-sub tc'>{t('about.for_whom.title')}</h3>
        <div className='s-32'></div>
        <div className='row'>
          <div className='col-lg-6'>
            <div className='card-review flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>👨‍💻</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.for_whom.categories.developers.title')}</h4>
                <p>
                  {t('about.for_whom.categories.developers.description')}
                </p>
              </div>
            </div>
            <div className='s-24'></div>
            <div className='card-review flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>🔍</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.for_whom.categories.beginners.title')}</h4>
                <p>
                  {t('about.for_whom.categories.beginners.description')}
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>🤔</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.for_whom.categories.tried.title')}</h4>
                <div className='s-10'></div>
                <p style={{ paddingRight: 18 }}>
                  {t('about.for_whom.categories.tried.description')}
                </p>
              </div>
            </div>
            <div className='s-24'></div>
            <div className='card-review flex aifs p-4' style={{ height: '180px' }}>
              <p className='title-icon'>🌐</p>
              <div className='px-3 p-t-12'>
                <h4 className='c-dark'>{t('about.for_whom.categories.everyone.title')}</h4>
                <p>
                  {t('about.for_whom.categories.everyone.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='s-48'></div>
        <div className='reviews bg-lpink'>
          <h3 className='title-sub tc'>{t('about.ai_for_all.title')}</h3>
          <div className='s-32'></div>
          <div className='row'>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>👨‍🎓</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.students.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.students.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>👨‍👩‍👧‍👦</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.family.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.family.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='flex aifs'>
                <p className='title-icon'>👴</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.veterans.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.veterans.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>👨‍🏫</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.educators.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.educators.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>👨‍💼</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.managers.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.managers.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>🚀</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.entrepreneurs.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.entrepreneurs.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>📢</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.marketers.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.marketers.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>🎨</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.creatives.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.creatives.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 m-y-24'>
              <div className='card-review flex aifs'>
                <p className='title-icon'>👥</p>
                <div className='px-3 p-t-12'>
                  <h4 className='c-dark'>{t('about.ai_for_all.groups.community.title')}</h4>
                  <p>
                    {t('about.ai_for_all.groups.community.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className='s-48'></div>
        </div>
        <div className='s-48'></div>
        
        {/* Секция "О нас" перенесена в конец страницы */}
        <section id='organization'>
          <div className='row'>
            <div className='col-12'>
              <div className='card-review bg-white p-4'>
                <h3 className='title-sub tc mb-4'>{t('about.organization.title')}</h3>
                <div className='text-center'>
                  <h4 className='c-dark mb-3'>{t('about.organization.name')}</h4>
                  <p className='mb-2'>{t('about.organization.code')}</p>
                  <p className='mb-2'>{t('about.organization.address')}</p>
                  <p className='mb-0'>{t('about.organization.director')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className='s-48'></div>
      </div>
    </section>
  );
};

export default About;
